import "jqueryui";
import "jquery-ui-touch-punch";
import { bindable, transient, computedFrom } from "aurelia-framework";
import { Guid } from "../../../utilities/guid";
import { Reflection } from "../../../utilities/reflection";

@transient()
export class DoubleSlider {

    private _attached: boolean;
    private _supportDivId: string = "supportDiv_" + Guid.generateGuid();

    public sliderRange: HTMLDivElement;
    public minLimitEl: HTMLDivElement;
    public maxLimitEl: HTMLDivElement;
    public firstValueEl: HTMLDivElement;
    public secondValueEl: HTMLDivElement;

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(x => x.minValue))
    public get minValueAsNumber(): number {
        return this.valueAsNumber(this.minValue);
    }

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(x => x.maxValue))
    public get maxValueAsNumber(): number {
        return this.valueAsNumber(this.maxValue);
    }

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(x => x.firstValue))
    public get firstValueAsNumber(): number {
        return this.valueAsNumber(this.firstValue);
    }

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(x => x.secondValue))
    public get secondValueAsNumber(): number {
        return this.valueAsNumber(this.secondValue);
    }

    @bindable
    firstValue: number = 20;

    @bindable
    secondValue: number = 60;

    @bindable
    minValue: number = 0;

    @bindable
    maxValue: number = 100;

    @bindable
    formatter: (x: number) => string = (x: number) => x && x > this.minValue && x < this.maxValue 
        ? x.toFixed(0) 
        : '';

    @bindable
    public label: string;

    @bindable
    public info: string = "";

    @bindable
    public showRangeValues: boolean = true;

    @bindable
    public step: number = 1;

    maxValueChanged() {
        this.attached();
    }

    minValueChanged() {
        this.attached();
    }

    firstValueChanged(newValue) {
        const firstValue = this.valueAsNumber(newValue);
        if (firstValue > this.secondValueAsNumber) {
            this.secondValue = newValue;
        }
        if(this._attached)
        {
            $(this.sliderRange)["slider"]("option", "values", [this.valueAsNumber(newValue), this.secondValueAsNumber]);
            $("#" + this._supportDivId).css("width", ((this.maxValueAsNumber - this.secondValueAsNumber) / this.maxValueAsNumber * 100) + "%");
        }
    }

    secondValueChanged(newValue) {
        const secondValue = this.valueAsNumber(newValue);
        if(this._attached)
        {
            $(this.sliderRange)["slider"]("option", "values", [this.firstValueAsNumber, secondValue]);
            $("#" + this._supportDivId).css("width", ((this.maxValueAsNumber - secondValue) / this.maxValueAsNumber * 100) + "%");
        }
    }

    bind() {
        if (this._attached) {
            if ($(this.sliderRange)["slider"]("instance")) {
                $(this.sliderRange)["slider"]("option", "values", [this.firstValueAsNumber, this.secondValueAsNumber]);
                $("#" + this._supportDivId).css("width", ((this.maxValueAsNumber - this.secondValueAsNumber) / this.maxValueAsNumber * 100) + "%");
            }            
        }
    }

    attached(): void {
        this._attached = true;
        setTimeout(() => {
            $("#" + this._supportDivId).remove();
            $(this.sliderRange)["slider"]({
                range: true,
                min: this.minValueAsNumber,
                max: this.maxValueAsNumber,
                values: [this.firstValueAsNumber, this.secondValueAsNumber],
                step: this.step,
                slide: (event, ui) => {
                    const val1 = ui.values[0];
                    const val2 = ui.values[1];
                    this.firstValue = this.valueAsNumber(val1);
                    this.secondValue = this.valueAsNumber(val2);
                    $("#" + this._supportDivId).css("width", 100 - ui.values[1] + "%");
                }
            })
            //.append(`<div id="${this._supportDivId}" class="ui-slider-support-handle" style="width: 50%"></div>`);
            $("#" + this._supportDivId).css("width", ((this.maxValueAsNumber - this.secondValueAsNumber) / this.maxValueAsNumber * 100) + "%");
        });
    }

    private valueAsNumber(val: string | number) {
        return val ? Number(val) : 0;
    }

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(z => z.sliderRange))
    get right() {
        const handle = <HTMLElement>$(this.sliderRange).find('.ui-slider-handle').get(1);
        return handle ? handle.style.left : 0;
    }

    @computedFrom(Reflection.getPropertyPath<DoubleSlider>(z => z.sliderRange))
    get left() {
        const handle = <HTMLElement>$(this.sliderRange).find('.ui-slider-handle').get(0);
        return handle ? handle.style.left : 0;
    }
}
